export default __webpack_public_path__ + "static/webRotator/svg/05b174094352f9071d146ef7892b9f52.svg";